import { Loader, LoaderProps } from 'rsuite';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

const LoadingMessage = <FormattedMessage id="loading" />;

const defaultStyle = {
  zIndex: 99,
  position: 'fixed' as any,
  margin: 'auto',
};

function PageLoader({ style, ...props }: LoaderProps) {
  return (
    <Loader
      backdrop
      size="md"
      content={LoadingMessage}
      vertical
      style={{ ...defaultStyle, ...style }}
      {...props}
    />
  );
}

export default PageLoader;
